import { APP_CONFIG } from "@/constants/config";
import { useAppSelector } from "@/redux/hook";
import { featureFlagState } from "@/redux/store";
import { FLAG_TICKET } from "@/types/featureFlag";
import { useMemo } from "react";

export const useIsEnableFeatureFlag = (ticket: FLAG_TICKET) => {
  const { entities } = useAppSelector(featureFlagState);

  return useMemo(() => {
    if (APP_CONFIG.FORCE_DISABLE_FEATURE_FLAGS?.split(";").includes(ticket)) return false;

    const flag = entities?.find((entity) => entity.ticket === ticket);

    // If flag does not exist, default to true
    if (!flag) {
      return true;
    }

    return flag.enable;
  }, [entities, ticket]);
};
